import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './Header.css';
import cx from 'classnames';
import { Navbar } from 'react-bootstrap';

// Internal Components
import Navigation from '../Navigation';
import Logo from '../Logo';
import Toaster from '../Toaster';
import LoadingBar from 'react-redux-loading-bar';
import HeaderLocationSearch from './HeaderLocationSearch';
import DropDownMenu from '../DropDownMenu/DropDownMenu';

// Redux action
import { toggleOpen, toggleClose } from '../../actions/Menu/toggleControl';

import history from '../../core/history';

function Header(props) {
  const {
    borderLess = false,
    formatMessage,
    searchDisablePages = ['/', '/home'],
    fixedHeader,
    becomeHeader,
    becomeHeaderCss
  } = props;

  const showMenu = useSelector(state => state.toggle.showMenu);
  const siteSettings = useSelector(state => state.siteSettings.data);
  const dispatch = useDispatch();

  const [searchHide, setSearchHide] = useState(true);
  const [load, setLoad] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const location = history.location ? history.location.pathname : null;

  const handleMenu = useCallback(() => {
    if (showMenu) {
      dispatch(toggleClose());
    } else {
      dispatch(toggleOpen());
    }
  }, [showMenu, dispatch]);

  const handleDisableSearchPages = useCallback(() => {
    let searchHidden = false;
    if (location && searchDisablePages.length > 0) {
      searchHidden = !!searchDisablePages.find(o => location === o);
    }
    setSearchHide(searchHidden);
  }, [location, searchDisablePages]);

  const openMenu = useCallback(() => {
    setIsOpen(true);
    document.body.classList.add('headerModalOpen');
  }, []);

  const openClose = useCallback(() => {
    setIsOpen(false);
    document.body.classList.remove('headerModalOpen');
  }, []);

  useEffect(() => {
    setLoad(true);
    handleDisableSearchPages();
  }, [handleDisableSearchPages]);

  useEffect(() => {
    handleDisableSearchPages();
  }, [location, handleDisableSearchPages]);

  let borderClass = borderLess ? s.rentAllHeaderBorderLess : '';

  return (
    <div className={s.root}>
      <Toaster />
      <LoadingBar />
      <Navbar
        fluid
        className={cx(
          s.rentAllHeader,
          'rentAllHeader',
          'hidden-print',
          borderClass,
          s.headerFlexContainer,
          s.paddingBottom18,
          { ['fixedHeader']: location === '/s' },
          { ['homeHeader']: location === '/' || location === '/home' },
          fixedHeader,
          becomeHeaderCss
        )}
        expanded={showMenu}
        onToggle={handleMenu}
      >
        <div className={cx(s.container, s.headerFlexBox, { [s.searchHeader]: location === '/s' }, 'containerSearch')}>
          <Navbar.Header className={cx('logoPadding', !showMenu ? 'normalPosition' : 'fixedPosition')}>
            <Navbar.Brand className={cx(s.homeLogo, 'navBrandRTL')}>
              <Logo link="/" className={cx(s.brand, s.brandImg)} />
            </Navbar.Brand>
          </Navbar.Header>

          {
            !searchHide && !becomeHeader && (
              <Navbar.Form pullLeft className={cx('commonHeaderSearchForm', 'headerSearchRTL')}>
                <HeaderLocationSearch />
              </Navbar.Form>
            )
          }

          <div onClick={openMenu}>
            <div className="closebtnHidden">
              <DropDownMenu />
            </div>
          </div>

          <div className={cx(isOpen ? s.menuOpen : s.menuClose, s.mobileMenu, 'homeMobileMenu')}>
            <div className={cx(s.rightMenuClose, 'closebtnHidden')}>
              <div className={s.closeButtonPosition}>
                <div className={cx(s.closeColor, 'closeColorRTL')} onClick={openClose}>
                  ×
                </div>
              </div>
            </div>
            <div onClick={()=>openClose}>
              <Navigation becomeHeader={becomeHeader} />
            </div>
          </div>
        </div>
      </Navbar>
    </div>
  );
}

Header.propTypes = {
  borderLess: PropTypes.bool,
  fixedHeader: PropTypes.any,
  becomeHeader: PropTypes.any,
  becomeHeaderCss: PropTypes.any,
  formatMessage: PropTypes.any,
  searchDisablePages: PropTypes.array
};

export default injectIntl(withStyles(s)(Header));
